import { Skeleton } from 'primereact/skeleton';
import { useContext } from 'react';
import { ThemeContext } from '../../../theme/ThemeContext';

const QuizStatCard = ({
  title,
  value,
  icon,
  bgColor = "#fff",
  detailList = [],
  valueSuffix,
  loading = false,
}) => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  return (
    <div
      className="border-0 rounded-2 shadow"
      style={{
        minHeight: 150,
        height: 150,
        display: "flex",
        alignItems: "center",
        padding: "1rem 1.5rem",
        position: "relative",
        overflow: "hidden",
        backgroundColor: loading ? (isDark ? "#191919" : "#fff") : bgColor,
      }}
    >
      {loading ? (
        <div style={{ display: 'flex', width: '100%', alignItems: 'center', gap: '14px' }}>
          {/* Icon Skeleton */}
          <Skeleton shape="circle" size="40px" />
          {/* Value & Title Skeleton */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <Skeleton width="60%" height="30px" />
            <Skeleton width="40%" height="20px" />
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: detailList.length > 0 ? "start" : "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexBasis: "40%",
              justifyContent: "center",
              textAlign: detailList.length > 0 ? "start" : "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
              <img src={icon} alt={title} style={{ width: 40, height: 40, objectFit: "contain" }} />
              <span className="text-dark" style={{ fontSize: 30, fontWeight: "bold", marginLeft: 14 }}>
                {value}
                {valueSuffix && (
                  <span style={{ fontSize: 14, marginLeft: 2 }}>{valueSuffix}</span>
                )}
              </span>
            </div>
            <div
              className="text-dark"
              style={{
                fontSize: 16,
                fontWeight: 600,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {title}
            </div>
          </div>
          {detailList.length > 0 && (
            <>
              <div style={{ width: 1, height: "70%", margin: "0 20px", alignSelf: "center" }} />
              <div
                className="text-dark"
                style={{ display: "flex", flexDirection: "column", justifyContent: "center", flexBasis: "60%" }}
              >
                {detailList.map((d, i) => (
                  <span key={i} style={{ fontSize: 14, marginBottom: 7 }}>
                    {d.label}: <b style={{ fontSize: 16 }}>{d.value}</b>
                  </span>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default QuizStatCard;
